import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveFinancialCategory(basePath) {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback(
    (categoryId, payload) => {
      setSaving(true);
      const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
      const request = categoryId
        ? quarkusApi.put(`${basePath}/${categoryId}`, payload, authHeader)
        : quarkusApi.post(basePath, payload, authHeader);
      return request.finally(() => setSaving(false));
    },
    [basePath],
  );

  return { save, isSaving };
}
